import { Coverage } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { OfferDetailItem } from '@sky-distribution/onboarding-commons-ui/lib/ItemDetailsModal/ItemDetailsModal.types';

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export interface CoverageWithMeta extends CoverageMeta {
  codeIdentifier: string;
  coverage: Coverage;
}

export type CoverageWithMetaMap = Map<string, CoverageWithMeta>;

export interface CoverageOptions {
  price: number;
  value: string;
  label: string;
}

export enum CoverageType {
  main = 'main',
  additional = 'additional',
  group = 'group',
}

export interface CoverageMeta {
  name?: string;
  description?: string;
  isHidden?: boolean;
  showToolbox?: boolean;
  includesCodes?: string[];
  triggeredBy?: string[];
  visibilityTriggerBy?: string[];
  icon?: string;
  fake?: boolean;
  type?: CoverageType;
  displayOrder?: number;
  hideTermValue?: boolean;
  editableTermValue?: boolean;
  maxTermValue?: number;
  minTermValue?: number;
  termCurrency?: string;
}

export interface UpdatedCoverage {
  index: number;
  updated: CoverageWithMeta;
}

export interface CoverageMetaList {
  [key: string]: CoverageMeta;
}

export interface CoveragesMap {
  [key: string]: CoverageWithMeta;
}

export interface DigitalCoverage extends CoverageWithMeta {
  fake: boolean;
  codeIdentifier: string;
  coverage: WithRequired<Coverage, 'codeIdentifier'>;
}

export interface DigitalCoverages {
  [key: string]: DigitalCoverage;
}

export type CoveragesDetails = {
  [key: string]: OfferDetailItem | OfferDetailItem[];
};
